/** Cove */
export enum enumCoveIDs {
    COMMENT_COUNT = `cove-count`,
    COMMENTS = `cove-comments`,
    CONTAINER = `cove`,
    FORM = `cove-form`,
    INPUT = `cove-input-body`,
    LOADING_MESSAGE = `coveLoader`,
    LOGIN = `cove-login`,
    NAME_INPUT = `cove-input-name`,
    NAME_MESSAGE = `cove-name-message`,
    NEW_ALERT = `cove-new-alert`,
    STYLE = `cove-style`,
    SUBMIT = `cove-submit`
}
export enum enumCoveClass {
    AVATAR = `cove-avatar`,
    BODY = `cove-body`,
    BUTTONS = `cove-buttons`,
    CANCEL = `cove-cancel`,
    COMMENT = `cove-comment`,
    DATE = `cove-date`,
    FOOTER = `cove-footer`,
    HEADER = `cove-header`,
    INPUT = `cove-input`,
    LIKE = `cove-like`,
    MEMBER_NAME = `cove-member-name`,
    META = `cove-meta`,
    REACTIONS = `cove-reaction-box`,
    REACTOR = `cove-reactor`,
    REPLIES = `cove-reply`,
}
export enum enumReactionTypes {
    AGREE = "agree",
    ANGRY = "angry",
    DISLIKE = "dislike",
    FUNNY = "funny",
    HAPPY = "happy",
    HEART = "heart",
    LIKE = "like",
    SHOCKED = "shocked"
}
export enum enumReactionOptions {
    LIKES = "likes",
    OFF = "off"
}

/* Podcast Player */
export enum enumPlayState {
    PLAYING = "playing",
    PAUSED = "paused",
    LOADING = "loading"
}

/* Utils */
export enum enumDisplay {
    SHOW = 'block',
    HIDE = 'none'
}
